export default __webpack_public_path__ + "assets/img/category-item02.png";